import { format, getTime, formatDistanceToNow } from 'date-fns';

// ----------------------------------------------------------------------

type InputValue = Date | string | number | null | undefined;

export function fDate(date: InputValue, newFormat?: string) {
  const fm = newFormat || 'MMM d, yyyy';
  if (!date) return '';

  try {
    const parsedDate =
      typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)
        ? new Date(date + 'T00:00:00')
        : new Date(date);

    return format(parsedDate, fm);
  } catch {
    return '';
  }
}

export function fDateTime(date: InputValue, newFormat?: string) {
  const fm = newFormat || 'MMM dd yyyy, p';
  return date ? format(new Date(date), fm) : '';
}

export function fTimestamp(date: InputValue) {
  return date ? getTime(new Date(date)) : '';
}

export function fToNow(date: InputValue) {
  return date
    ? formatDistanceToNow(new Date(date), {
        addSuffix: true,
      })
    : '';
}

export function getDaysDifference(startDate: Date, endDate: Date): number {
  if (!startDate || !endDate) {
    return -1;
  }

  endDate.setHours(0, 0, 0, 0);

  const timeDifference = endDate.getTime() - startDate.getTime();
  const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));

  return daysDifference;
}

export function fTimeZone(timeZone: string) {
  const now = new Date();

  const abbreviatedTimeZone = new Intl.DateTimeFormat('en-US', {
    timeZone,
    timeZoneName: 'short',
  })
    .formatToParts(now)
    .find((part) => part.type === 'timeZoneName')?.value;

  if (abbreviatedTimeZone) {
    return timeZone + ' (' + abbreviatedTimeZone + ')';
  }

  return 'Unknown timezone';
}

export function fDateTimeWithTz(date: InputValue, timeZone?: string) {
  if (!date) return '';

  const dateObj = new Date(date);

  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    timeZone: timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone,
    timeZoneName: 'short',
  };

  return new Intl.DateTimeFormat('en-US', options).format(dateObj);
}
